import React, { useEffect } from "react";
import Slider from "react-slick";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import NavigateNext from "@material-ui/icons/NavigateNext";
import styles from "./styles";
import CardPlan from "./CardPlan";
import { useDispatch, useSelector } from "react-redux";
import { getPlans } from "../../actions/plans";

export const RightNavButton = (props: any) => {
  return (
    <button
      onClick={props.onClick}
      type="button"
      className="btn btn-default slick-arrow slick-custom slick-custom-rigth rigth-arrow-slider"
    >
      <NavigateNext style={{ fontSize: "2.5rem" }} />
    </button>
  );
};

export const LeftNavButton = (props: any) => {
  return (
    <button
      onClick={props.onClick}
      type="button"
      className="btn btn-default slick-arrow slick-custom slick-custom-left left-arrow-slider"
    >
      <NavigateBefore style={{ fontSize: "2.5rem" }} />
    </button>
  );
};

export const PlansSlider = () => {
  const dispatch = useDispatch();
  const { plans } = useSelector(state => state.plans);
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <RightNavButton />,
    prevArrow: <LeftNavButton />,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const classes = styles();
  useEffect(() => {
    dispatch(getPlans());
  }, []);

  return (
    <div className={classes.sliderContainer}>
      <Slider {...settings} className={classes.sliderStyle}>
        {plans?.map((plan, index) => (
          <div key={index}>
            <CardPlan plan={plan} />
          </div>
        ))}
      </Slider>
    </div>
  );
};
